import { render, staticRenderFns } from "./ProrrogarAluguelDialog.vue?vue&type=template&id=19512ee0&"
import script from "./ProrrogarAluguelDialog.vue?vue&type=script&lang=js&"
export * from "./ProrrogarAluguelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports